import { Component, output, EventEmitter, Output, TemplateRef, ViewChild } from '@angular/core';
import { ICard } from '../../../shared/models/card.model';
import { CardComponent } from '../../../shared/components/card/card.component';
import { TodoService } from '.././services/todo.service';
import { IEvent, IEventResponse, IData } from '.././models/event';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule, NgFor } from '@angular/common';
import { MatPaginator } from '@angular/material/paginator';
import { FormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { PaginatorComponent } from "../../../shared/components/paginator/paginator.component";
import { MatDialogModule, MatDialog } from '@angular/material/dialog';
import { HeroComponent } from "../../../shared/components/hero/hero.component";
import { HttpClient, HttpClientModule, provideHttpClient } from '@angular/common/http';

@Component({
  selector: 'app-archived',
  standalone: true,
  imports: [MatIconModule, CommonModule, FormsModule, MatTabsModule, MatTableModule, NgFor, PaginatorComponent, MatDialogModule, HeroComponent, HttpClientModule],
  templateUrl: './archived.component.html',
  styleUrl: './archived.component.scss'
})
export class ArchivedComponent {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @Output() paginationChange = new EventEmitter<{ pageIndex: number; pageSize: number }>();
  @ViewChild('editDialogTemplate') editDialogTemplate!: TemplateRef<any>;
  @ViewChild('addDialogTemplate') addDialogTemplate!: TemplateRef<any>;

  constructor(
    public dialog: MatDialog,
    private todoService: TodoService,
    private http: HttpClient
  ) {}
  
  resultsLength: number = 5;
  pageSize: number = 5;
  pageSizeOptions = [5, 10, 15];

  data: IData[] = [];
  fullData: IData[] = [];

  currentPage = 0;
  selected: any;
  loadingEvent = output<boolean>();
  errorMessages: string | undefined;

  columns = ['Site', 'Packing List Reference Number', 'Attachments', 'Distinct PL Reference', 'Date Received', 'Despatch Date', 'Actual PL Notice Days', 'Issues', 'Issue Type', 'Narrative', 'Who', 'Customer', 'AZ Commercial Invoice', 'Toll Principal'];
  filters = ['Site', 'Packing List Reference Number', 'District', 'Date Received', 'Despatch Date', 'Actual PL Notice', 'Issues', 'Issue Type', 'Who', 'Customer', 'AZ Commercial Invoice', 'Toll Principal'];

  getRow(row: IData, key: string): string | number {
    key = key.replaceAll(' ', '');
    return row[key as keyof IData];
  }

  loadData() {
    this.http.get<IData[]>('/assets/data.json').subscribe({
      next: (data) => {
        this.fullData = data;
        this.filterNonArchived();
      },
      error: (error) => {
        this.errorMessages = error.message;
        console.error('Failed to load data:', error);
      },
    });
  }

  downloadFile() {
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute('href', 'assets/attachment_example.pdf');
    link.setAttribute('download', 'attachment_example.pdf');
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  ngOnInit() {
    this.loadData();
  }

  openEditDialog(row: any): void {
    this.selected = row;
    //console.log(this.selected);
    this.dialog.open(this.editDialogTemplate, {
      width: '816px',
      maxWidth: '816px',
      data: { data: row },
    });
  }

  saveChanges() {
    if (this.selected) {
      this.editEntry(this.selected);
      this.dialog.closeAll();
    }
  }

  filterNonArchived() {
    this.data = this.fullData.filter(item => item.isArchived === 'True');
    this.resultsLength = this.data.length;
  }

  editEntry(updatedData: any) {
    const index = this.data.findIndex(item => item.PackingListReferenceNumber === updatedData.PackingListReferenceNumber);
    if (index !== -1) {
      this.data[index] = { ...updatedData };
      //console.log('Updated entry:', this.data[index]);
    }
  }

  deleteRow(row: IData): void {
    const index = this.fullData.findIndex(item => item.PackingListReferenceNumber === row.PackingListReferenceNumber);
    if (index !== -1) {
      this.fullData[index].isArchived = 'True';
      this.filterNonArchived();
    }
  }

  openAddDialog(): void {
    //console.log(this.selected);
    this.dialog.open(this.addDialogTemplate, {
      width: '816px',
      maxWidth: '816px',
    });
  }

  onPageChange(event: { pageIndex: number; pageSize: number }): void {
    this.paginationChange.emit(event);
  }

  pageSizeChange(pageSize: number): void {
    this.pageSize = pageSize;
    this.paginationChange.emit({ pageIndex: 0, pageSize });
  }
}